<template>
  <div>
    <imgHeader imgUrl="/img/10业务领域-banner.jpg" />
    <div class="w main">
      <h3 class="title" style="text-align: center">{{ $t('businessField.title') }}</h3>
      <div class="line line1"></div>
      <div class="container flex">
        <div
            class="card"
            v-for="item in list"
            :key="item.key"
            data-aos="fade-right"
            data-aos-duration="500"
        >
          <div class="card-img">
            <img :src="item.imgUrl" alt="" />
          </div>
          <div class="card-title">{{ item.title }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { t } from '@/VueI18n'

export default {
  name: 'BusinessField',

  data() {
    return {
      list: [
        {
          key: 'internationalTrade',
          title: t('businessField.internationalTrade'),
          imgUrl: require('/public/img/10业务领域-img1.jpg'),
        },
        {
          key: 'industrialInvestment',
          title: t('businessField.industrialInvestment'),
          imgUrl: require('/public/img/10业务领域-img2.jpg'),
        },
        {
          key: 'warehouseLogistics',
          title: t('businessField.warehouseLogistics'),
          imgUrl: require('/public/img/10业务领域-img3.jpg'),
        },
        {
          key: 'productionProcessing',
          title: t('businessField.productionProcessing'),
          imgUrl: require('/public/img/10业务领域-img4.jpg'),
        },
      ],
    }
  },

  watch: {
    '$i18n.locale'() {
      this.updateTitles()
    }
  },

  mounted() {
    this.updateTitles()
  },

  methods: {
    updateTitles() {
      this.list = this.list.map(item => ({
        ...item,
        title: t(`businessField.${item.key}`)
      }))
    }
  },
}
</script>

<style lang="scss" scoped>
.main {
  margin-bottom: 50px;
}
.container {
  margin-top: 60px;
  justify-content: space-between;
  flex-wrap: wrap;
}
.card {
  margin-bottom: 40px;
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.2);
  &:hover {
    transform: scale(1.03);
  }
}
.card-img {
  font-size: 0px;
  img {
    width: 100%;
  }
}
.card-title {
  padding: 20px 10px;
  border: 1px solid #eaeaea;
  border-top: none;
  text-align: center;
  font-size: 18px;
}
</style>